class AppHeight {
  constructor() {
    this.initialize()
  }

  initialize() {
    this.updateHeight()
  }

  updateHeight() {
    document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`)
  }
}

export default AppHeight
